import { render, staticRenderFns } from "./watermark.vue?vue&type=template&id=d7e2e872&scoped=true"
import script from "./watermark.vue?vue&type=script&lang=js"
export * from "./watermark.vue?vue&type=script&lang=js"
import style0 from "./watermark.vue?vue&type=style&index=0&id=d7e2e872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e2e872",
  null
  
)

export default component.exports